import {
    Container, Divider, Typography,
} from '@mui/material';
import { LoggedInUser } from '../../../types/auth.types';
import Anchor from '../foundation/Anchor';
import { BGContainer, WhiteBGContainer } from '../foundation/Containers';
import CustomBR from '../foundation/CustomBR';
import Page from '../layout/base.page';

export type AboutProps = {
    url: string
    user?: LoggedInUser
}

const About = (props: AboutProps): JSX.Element => <Page
    url={props.url}
    user={props.user}
    pageHeaderTitle="Mploy - Jobs - About Us" >
    <Container style={{ direction: 'ltr' }}>
        <CustomBR />
        <BGContainer>
            <Typography color="secondary" fontWeight="bold" variant="h4">Mploy - Job Board | Job Search</Typography>
            <CustomBR />
            <WhiteBGContainer>
                <Typography color="secondary" variant="body1">
                Mploy is an AI-based job board designed to assist both job seekers and employers, creating an innovative and high-quality platform that leads the job market.
                    <CustomBR />
We aggregate up-to-date job listings from thousands of sources across the country and make them accessible efficiently through a smart AI agent that matches relevant jobs to candidates and allows applications with a single click.
                    <CustomBR />
Our platform offers AI-based job matching with a personal match percentage, dedicated WhatsApp groups by field, and an advanced app that allows you to search and send resumes from anywhere, anytime.
                </Typography>
            </WhiteBGContainer>
            <CustomBR />
            <CustomBR />
            <Typography color="secondary" fontWeight="bold" variant="h4">A High-Quality App</Typography>
            <CustomBR />
            <WhiteBGContainer>
                <Typography color="secondary" variant="body1">
With Mploy, you can search for available jobs directly from your mobile device.
We provide a first-of-its-kind app that, in addition to searching for jobs by location, fields, and keywords, offers a convenient and easy-to-use experience, allowing you to send resumes to relevant jobs effortlessly, anytime and anywhere.
                </Typography>
            </WhiteBGContainer>
            <CustomBR />
            <CustomBR />
            <Typography color="secondary" fontWeight="bold" variant="h4">Jobs from the Web</Typography>
            <CustomBR />
            <WhiteBGContainer>
                <Typography color="secondary" variant="body1">
To reach most of the jobs in the Israeli job market, we also collect job listings from social networks and various places on the web.
                    <CustomBR />
Instead of searching for jobs on social networks and going through many irrelevant listings, we have centralized all the jobs on our platform, allowing you to easily filter jobs by fields, roles, keywords, and distance, both on the website and through the mobile app.
                    <CustomBR />
                    <CustomBR />
                    <Anchor text="Join our smart agent" href="/qsa" blank /> and receive updates about new jobs from the web directly to your email inbox.
                </Typography>
            </WhiteBGContainer>
            <CustomBR />
            <CustomBR />
            <Typography color="secondary" fontWeight="bold" variant="h4">Job Posting</Typography>
            <CustomBR />
            <WhiteBGContainer>
                <Typography color="secondary" variant="body1">
                 Posting a job on Mploy is easy.
                    <CustomBR />
Moreover, every employer receives a dashboard where they can view the jobs they have posted, details of interested candidates, and edit or remove existing jobs quickly and easily.
The team at Mploy emphasizes the reliability of candidates as well as the credibility of the jobs offered to candidates.
Every job and candidate on the site must comply with the <Anchor text="site regulations" href="/home/regulations" blank />.
                </Typography>
            </WhiteBGContainer>
            <CustomBR />
            <Divider />
            <CustomBR />
            <WhiteBGContainer>
                <Typography color="secondary" variant="body1">
We make every effort to offer candidates the most suitable jobs in the job market by quickly filtering using algorithms based on fields, roles, keywords, and the candidate's location.
                    <CustomBR />
We invite you to read our <Anchor text="Terms of Use and Privacy Policy" href="/home/privacy" blank />.
                </Typography>
            </WhiteBGContainer>
            <CustomBR />
        </BGContainer>
    </Container>
    <CustomBR />
</Page>;

export default About;
